import React from 'react';
import styled from 'styled-components';

const LauncherContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  z-index: 999;
`;

const ChatBubble = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(145deg, rgba(35, 35, 35, 0.95) 0%, rgba(0, 0, 0, 0.9) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }
`;

const ChatIcon = styled.div`
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 5px;
    right: -2px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 10px 10px;
    border-color: transparent transparent white transparent;
    transform: rotate(-30deg);
  }
`;

const UnreadBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #f44336;
  color: white;
  border-radius: 50%;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid white;
`;

interface ChatLauncherProps {
  onClick: () => void;
  unreadCount: number;
}

export const ChatLauncher: React.FC<ChatLauncherProps> = ({ onClick, unreadCount }) => {
  return (
    <LauncherContainer onClick={onClick}>
      <ChatBubble>
        <ChatIcon />
        {unreadCount > 0 && <UnreadBadge>{unreadCount}</UnreadBadge>}
      </ChatBubble>
    </LauncherContainer>
  );
}; 
